export default `
<link rel="stylesheet" href="https://animate.style/animate.min.css">
<style>
  .rip-mm-cd-labels {
    display: flex;
    gap: 16px;
    justify-content: center;
  }

  .rip-mm-cd-labels .label {
    width: 140px;
  }


  .rip-mm-cd-wrapper {
    display: flex;
    gap: 16px;
    justify-content: center;
  }

  .rip-mm-cd-wrapper.face-text {
    display: flex;
    gap: 30px;
    justify-content: center;
  }

  .rip-mm-cd-text {
    font-size: 80px;
    font-weight: 700;
    line-height: 87px;
  }

  .rim-mm-cd-label {
    width: 100%;
    text-align: center;
    font-size: 24px;
  }

  .rip-mm-cd-text.cd-colon::after {
    content: ":";
    font-size: 80px;
    font-weight: 700;
    line-height: 87px;
    top: -6px;
    right: -26px;
    position: absolute;
  }

  .rip-mm-cd-text-container {
    display: flex;
    position: relative;
  }

  .rip-mm-cd-group {
    text-align: center;
    width: 140px;
    position: relative;
    height: 128px;
  }

  .rip-mm-cd-flip-container {
    display: flex;
  }

  .rip-mm-cd-flip {
    position: relative;
    float: left;
    margin: 0 4px;
    width: 60px;
    height: 90px;
    font-size: 80px;
    font-weight: bold;
    line-height: 87px;
    border-radius: 6px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, .7);
  }

  .rim-mm-cd-scale {
    transition: all .3s linear;
  }

  .rip-mm-cd-flip li {
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .rip-mm-cd-flip li:first-child {
    z-index: 2;
  }

  .rip-mm-cd-flip li {
    display: block;
    height: 100%;
    perspective: 200px;
  }

  .rip-mm-cd-flip li div {
    z-index: 1;
    position: absolute;
    left: 0;
    width: 100%;
    height: 50%;
    overflow: hidden;
  }

  .rip-mm-cd-flip li div .shadow {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;
  }

  .rip-mm-cd-flip li div.up {
    transform-origin: 50% 100%;
    top: 0;
  }

  .rip-mm-cd-flip li div.up:after {
  content: "";
  position:absolute;
  top:44px;
  left:0;
  z-index: 5;
    width: 100%;
  height: 3px;
  background-color: rgba(0,0,0,.4);
  }

  .rip-mm-cd-flip li div.down {
    transform-origin: 50% 0%;
    bottom: 0;
  }

  .rip-mm-cd-flip li div div.inn {
    position: absolute;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 200%;
    color: #ccc;
    text-shadow: 0 1px 2px #000;
    text-align: center;
    background-color: #333;
    border-radius: 6px;
  }

  .rip-mm-cd-flip li div.up div.inn {
    top: 0;

  }

  .rip-mm-cd-flip li div.down div.inn {
    bottom: 0;
  }

  /* PLAY */

  body.play .rip-mm-cd-flip li.before {
    z-index: 3;
  }

  body.play .rip-mm-cd-flip li.active {
    animation: asd .5s .5s linear both;
    z-index: 2;
  }

  @keyframes asd {
    0% {
        z-index: 2;
    }
    5% {
        z-index: 4;
    }
    100% {
        z-index: 4;
    }
  }

  body.play .rip-mm-cd-flip li.active .down {
    z-index: 2;
    animation: turn .5s .5s linear both;
  }

  @keyframes turn {
    0% {
        transform: rotateX(90deg);
    }
    100% {
        transform: rotateX(0deg);
    }
  }

  body.play .rip-mm-cd-flip li.before .up {
    z-index: 2;
    animation: turn2 .5s linear both;
  }

  @keyframes turn2 {
    0% {
        transform: rotateX(0deg);
    }
    100% {
        transform: rotateX(-90deg);
    }
  }

  /* SHADOW */

  body.play .rip-mm-cd-flip li.before .up .shadow {
    background: -moz-linear-gradient(top, rgba(0, 0, 0, .1) 0%, rgba(0, 0, 0, 1) 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, .1)), color-stop(100%, rgba(0, 0, 0, 1)));
    background: linear-gradient(top, rgba(0, 0, 0, .1) 0%, rgba(0, 0, 0, 1) 100%);
    background: -o-linear-gradient(top, rgba(0, 0, 0, .1) 0%, rgba(0, 0, 0, 1) 100%);
    background: -ms-linear-gradient(top, rgba(0, 0, 0, .1) 0%, rgba(0, 0, 0, 1) 100%);
    background: linear-gradient(to bottom, rgba(0, 0, 0, .1) 0%, rgba(0, 0, 0, 1) 100%);
    animation: show .5s linear both;
  }

  body.play .rip-mm-cd-flip li.active .up .shadow {
    background: -moz-linear-gradient(top, rgba(0, 0, 0, .1) 0%, rgba(0, 0, 0, 1) 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, .1)), color-stop(100%, rgba(0, 0, 0, 1)));
    background: linear-gradient(top, rgba(0, 0, 0, .1) 0%, rgba(0, 0, 0, 1) 100%);
    background: -o-linear-gradient(top, rgba(0, 0, 0, .1) 0%, rgba(0, 0, 0, 1) 100%);
    background: -ms-linear-gradient(top, rgba(0, 0, 0, .1) 0%, rgba(0, 0, 0, 1) 100%);
    background: linear-gradient(to bottom, rgba(0, 0, 0, .1) 0%, rgba(0, 0, 0, 1) 100%);
    animation: hide .5s .3s linear both;
  }

  /*DOWN*/

  body.play .rip-mm-cd-flip li.before .down .shadow {
    background: -moz-linear-gradient(top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, .1) 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, 1)), color-stop(100%, rgba(0, 0, 0, .1)));
    background: linear-gradient(top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, .1) 100%);
    background: -o-linear-gradient(top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, .1) 100%);
    background: -ms-linear-gradient(top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, .1) 100%);
    background: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, .1) 100%);
    animation: show .5s linear both;
  }

  body.play .rip-mm-cd-flip li.active .down .shadow {
    background: -moz-linear-gradient(top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, .1) 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, 1)), color-stop(100%, rgba(0, 0, 0, .1)));
    background: linear-gradient(top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, .1) 100%);
    background: -o-linear-gradient(top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, .1) 100%);
    background: -ms-linear-gradient(top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, .1) 100%);
    background: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, .1) 100%);
    animation: hide .5s .3s linear both;
  }

  @keyframes show {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
  }

  @keyframes hide {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
  }
</style>
<script>
  function calculateFutureTime(days = 0, hours = 0, minutes = 0) {
    const daysInMilliseconds = days * 24 * 60 * 60 * 1000;
    const hoursInMilliseconds = hours * 60 * 60 * 1000;
    const minutesInMilliseconds = minutes * 60 * 1000;
    const totalMilliseconds =
      daysInMilliseconds + hoursInMilliseconds + minutesInMilliseconds;
    return new Date().getTime() + totalMilliseconds;
  }

  function calculateTimeDifference(endDateTimestamp) {
    const endDate = new Date(+endDateTimestamp);
    const now = new Date();
    const difference = endDate - now;

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    const datetimeUnits = {
      minutes: minutes >= 0 ? minutes.toString().padStart(2, "0") : "00",
      seconds: seconds >= 0 ? seconds.toString().padStart(2, "0") : "00",
    };

    if (days > 0) {
      datetimeUnits.showDays = true;
      datetimeUnits.days = days.toString().padStart(2, "0");
    }

    if (days > 0 || hours > 0) {
      datetimeUnits.showHours = true;
      datetimeUnits.hours = hours.toString().padStart(2, "0");
    }

    return datetimeUnits;
  }
    
  function setCookie(name, value, timestamp) {
    var expires = "";
    if (timestamp) {
      var date = new Date();
      date.setTime(timestamp);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    let matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$&") +
          "=([^;]*)"
      )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  function textCountdown(shortId, obj) {
    if (obj.showDays) {
      $("#" + shortId + " .rip-mm-cd-text.h1").text(obj.days[0]);
      $("#" + shortId + " .rip-mm-cd-text.d2").text(obj.days[1]);
    }

    if (obj.showHours) {
      $("#" + shortId + " .rip-mm-cd-text.h1").text(obj.hours[0]);
      $("#" + shortId + " .rip-mm-cd-text.h2").text(obj.hours[1]);
    }
    $("#" + shortId + " .rip-mm-cd-text.m1").text(obj.minutes[0]);
    $("#" + shortId + " .rip-mm-cd-text.m2").text(obj.minutes[1]);

    $("#" + shortId + " .rip-mm-cd-text.s1").text(obj.seconds[0]);
    $("#" + shortId + " .rip-mm-cd-text.s2").text(obj.seconds[1]);
  }

  function flipCountdown(shortId, obj) {
    if (obj.showDays) {
      digitalAnimation("#" + shortId + " .rip-mm-cd-flip.d2", obj.days[0]);
      digitalAnimation("#" + shortId + " .rip-mm-cd-flip.d2", obj.days[1]);
    }

    if (obj.showHours) {
      digitalAnimation("#" + shortId + " .rip-mm-cd-flip.h1", obj.hours[0]);
      digitalAnimation("#" + shortId + " .rip-mm-cd-flip.h2", obj.hours[1]);
    }
    digitalAnimation("#" + shortId + " .rip-mm-cd-flip.m1", obj.minutes[0]);
    digitalAnimation("#" + shortId + " .rip-mm-cd-flip.m2", obj.minutes[1]);

    digitalAnimation("#" + shortId + " .rip-mm-cd-flip.s1", obj.seconds[0]);
    digitalAnimation("#" + shortId + " .rip-mm-cd-flip.s2", obj.seconds[1]);
  }

  function digitalAnimation(parentSelector, num) {
    var aa = $(parentSelector).find("li.active");
    var bb = $(parentSelector).find("li.before");
    var current = aa.find(".inn").first().text();
    if (num === current) return;

    if (aa.html() == undefined) {
      aa = $(parentSelector).find(".rip-mm-cd-aa");
      aa.find(".inn").text(num);
      aa.addClass("active");
      bb = $(parentSelector).find(".rip-mm-cd-bb");
      bb.addClass("before");
    } else {
      $(parentSelector).find("li").removeClass("before");

      aa.addClass("before").removeClass("active");

      bb.find(".inn").text(num);

      bb.addClass("active").removeClass("before");
      $("body").addClass("play");
    }
  }
</script>
`;